export const SETTING_CONFIG = {
    requests: {
        getGroups: {
            url: `dbms/itemgroups`,
        },
        getGroupCatalogy: {
            url: `dbms/itemcatalogs`,
        },
        getBranchs: {
            url: `dbms/branchs`,
        },
        getItemMasters: {
            url: `dbms/items`,
        },
        getUnits: {
            url: `dbms/units`,
        },
        searchAddress: {
            url: `address`,
        },
        getWherehouses: {
            url: `dbms/warehouses`,
        },
        getZones: {
            url: `dbms/zones`,
        },
        getCustomer: {
            url: `customers`,
        },
        getEmployee: {
            url: `employees`,
        },
        getRoles: {
            url: `dbms/roles`,
        },
        getItemTypes: {
            url: `dbms/itemtypes`,
        },
        getBudgetYears: {
            url: `dbms/budget-years`,
        },
        ChangePassword: {
            url: `profile/user`, 
        }
    },
};
